import {
  filterPromptsForContext,
  isPromptUsable,
} from "../constants/chatConstants";
import type { CrmRecordType, ManagingPromptCatalogEntry } from "../types/chat.types";

export function isSlashPromptMode(value: string): boolean {
  return value.startsWith("/");
}

export function slashPromptQuery(value: string): string {
  return isSlashPromptMode(value) ? value.slice(1) : "";
}

export function filterSlashPrompts(
  prompts: ManagingPromptCatalogEntry[],
  opts: {
    recordType?: CrmRecordType | null;
    query: string;
    hasCallRecordingWithTranscript?: boolean;
  }
): ManagingPromptCatalogEntry[] {
  const base = filterPromptsForContext(prompts, { recordType: opts.recordType });
  const q = opts.query.trim().toLowerCase();
  const filtered = q
    ? base.filter(
        (p) =>
          p.name.toLowerCase().includes(q) ||
          p.description.toLowerCase().includes(q) ||
          p.promptType.toLowerCase().includes(q)
      )
    : base;
  return filtered;
}

export function firstSelectableSlashIndex(
  prompts: ManagingPromptCatalogEntry[],
  recordType?: CrmRecordType | null,
  opts?: { hasCallRecordingWithTranscript?: boolean }
): number {
  return prompts.findIndex(
    (p) => isPromptUsable(p, recordType, opts).usable
  );
}
